import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/SpeakingScreen.css';

const SpeakingScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { speaking, title } = location.state || {};

  const showContent = (file, translationFile) => {
    navigate('/content-screen', { state: { content: file.content, name: file.name, translation: translationFile.content } });
  };

  const getContentByLanguage = (language) => {
    const languageObject = speaking.find((speak) => speak.name === language);
    return languageObject ? languageObject.content : null;
  };

  const getFileAtIndex = (speakingArray, index) => {
    return speakingArray[index];
  };

  const fi_speaking = getContentByLanguage('fi');
  const user_language_speaking = getContentByLanguage('en');

  return (
    <div className="container">
      <BackButton to="/speaking" label="Speaking" />
      <h2 className="page-title">{title}</h2>
      <div className="content-list">
        {fi_speaking.map((file, index) => (
          <div
            key={index}
            className="content-list-item"
            onClick={() => showContent(file, getFileAtIndex(user_language_speaking, index))}
          >
            <div className="content-list-icon"><Icon name="mic" size={20} color="var(--text-secondary)" /></div>
            <span className="content-list-text">{file.name}</span>
            <span className="content-list-arrow">&rsaquo;</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpeakingScreen;
